/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Invite_CrumbInputs */

const en_booking_invite_crumb = /** @type {(inputs: Booking_Invite_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite`)
};

const pl_booking_invite_crumb = /** @type {(inputs: Booking_Invite_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaproszenie`)
};

/**
* | output |
* | --- |
* | "Invite" |
*
* @param {Booking_Invite_CrumbInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const booking_invite_crumb = /** @type {((inputs?: Booking_Invite_CrumbInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Invite_CrumbInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_booking_invite_crumb(inputs)
	return en_booking_invite_crumb(inputs)
});